<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu [disabled]="isDisableSideMenu" contentId="main-content" type="overlay">
      <ion-content>
        <ion-list id="inbox-list">
          <ion-list-header class="header-title">
            <img class="nospot-log"
                 src="assets/icon/shared/nospot_logo.png" alt="">NOSPOT
          </ion-list-header>
          @for (p of appPages; track p; let i = $index) {
            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false"
                        routerLinkActive="selected">
                <ion-icon slot="start"
                          [src]="'assets/icon/sidemenu/' + p?.icon + '.svg'"></ion-icon>
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
        </ion-list>
        <div class="under-menu">
          <div>
            <label>公開期間</label>
            <p class="public-period">
              {{ projectService?.currentProject?.startDate | date: 'yyyy/MM/dd' }}
              〜{{ projectService?.currentProject?.endDate | date: 'yyyy/MM/dd' }}
            </p>
          </div>
          <ng-container *ngIf="isPublicPeriod; else outsidePublicPeriod">
            <div (click)="togglePublic()" class="slide-toggle">
              <div class="public-btn public" [class.public]="projectService?.currentProject?.publicSetting"
                   [style.color]="projectService?.currentProject?.publicSetting ? '#FFFFFF' : '#667085'">公開
              </div>
              <div class="private-btn private" [class.private]="!projectService?.currentProject?.publicSetting"
                   [style.color]="!projectService?.currentProject?.publicSetting ? '#FFFFFF' : '#667085'">非公開
              </div>
            </div>
          </ng-container>
          <ng-template #outsidePublicPeriod>
            @if (projectService?.currentProject?.publicSetting) {
              <ion-button disabled (click)="togglePublic()" mode="ios" shape="round" color="medium" class="toggle-public-btn">
                公開する
              </ion-button>
            } @else {
              <ion-button (click)="togglePublic()" mode="ios" shape="round" class="toggle-public-btn">公開する
              </ion-button>
            }
          </ng-template>
        </div>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>

<ion-modal [isOpen]="isOpenPrivateMessageModal" (didDismiss)="isOpenPrivateMessageModal = false"
           class="check-private-modal">
  <ng-template>
    <div (click)="isOpenPrivateMessageModal = false" class="close-btn">
      <ion-icon class="close-icon" name="close"></ion-icon>
      <p>閉じる</p>
    </div>
    <div class="check-block">
      <h1 class="check-block__title">非公開にすると、サイトが見れなくなりますがよろしいでしょうか？</h1>
      <ion-button (click)="makePrivate()" class="check-block__private-btn" expand="block">非公開にする</ion-button>
      <p class="check-block__message">公開に戻すとサイトは再度公開されます</p>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="isPreviewModalOpen" class="preview-modal" (didDismiss)="isPreviewModalOpen = false">
  <ng-template>
    <div class="content">
      <div (click)="isPreviewModalOpen = false" class="close-btn">
        <ion-icon class="close-icon" name="close"></ion-icon>
        <p>閉じる</p>
      </div>
      <h1 class="preview-title">
        変更内容を公開しますか
      </h1>
      <h2 class="description">
        プレビューにて問題ないかご確認の上、公開してください。<br>
        「更新する」を押したら本番サイトへ反映されます。
      </h2>
      <a (click)="previewPcView()" class="pc-link">PCで確認したい方はこちら</a>
      <div class="preview-map">
        <app-map-preview></app-map-preview>
      </div>
      <ion-button (click)="publicProject()" expand="block" class="update-btn" shape="round">
        公開する
      </ion-button>
    </div>
  </ng-template>
</ion-modal>
